import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  email,
  translate
} from "admin-on-rest";
import {
  validatePartnerDataEdit,
  validatePassword,
  validateCompanyNumber,
  validateZipCode
} from "./validations";
import {formStyle} from "./style";

const PartnerTitleBase = ({record, translate}) => {
  return (
    <span style={formStyle.titleStyle}>
      {translate("resources.storeOwners.titleEdit")}{" "}
      {record ? `  ${record.first_name} ${record.last_name}` : ""}
    </span>
  );
};

const PartnerTitle = translate(PartnerTitleBase);

class PartnerEditForm extends React.Component {
  render() {
    const props = {...this.props};
    return (
      <Edit title={<PartnerTitle />} {...props}>
        <SimpleForm validate={validatePartnerDataEdit}>
          <TextInput
            label="resources.storeOwners.inputs.firstName"
            source="first_name"
          />
          <TextInput
            label="resources.storeOwners.inputs.lastName"
            source="last_name"
          />
          <TextInput
            label="resources.storeOwners.inputs.email"
            source="email"
            type="email"
            validate={email}
          />
          <TextInput
            label="resources.storeOwners.inputs.password"
            source="password"
            type="password"
            validate={validatePassword}
            style={formStyle.containerInput}
          />
          <TextInput
            label="resources.storeOwners.inputs.repeatPassword"
            source="password2"
            type="password"
            validate={validatePassword}
          />
          <div style={formStyle.clearFloatContainer} />
          <TextInput
            label="resources.storeOwners.inputs.companyName"
            source="company_name"
          />
          <TextInput
            label="resources.storeOwners.inputs.companyNumber"
            source="company_number"
            validate={validateCompanyNumber}
          />
          <TextInput
            label="resources.storeOwners.inputs.city"
            source="city"
            style={formStyle.containerInput}
          />
          <TextInput
            label="resources.storeOwners.inputs.postNumber"
            source="post_number"
            validate={validateZipCode}
          />
        </SimpleForm>
      </Edit>
    );
  }
}

export default PartnerEditForm;



// WEBPACK FOOTER //
// ./src/containers/CRM/Partners/PartnerEditForm.js